import ENV from "config/Env";
import { ApiInstance } from "utils/Api";

type PdfDownloadDealerPayload = {
  dealer_id: number;
  document_id: number;
};

export const downloadDealerLicenseInvoice = async (requestData: PdfDownloadDealerPayload) => {
  const response = await ApiInstance.post("/invoices/download", requestData, ENV.exactBaseURL, { responseType: "blob" });
  return response;
};
